import { useState, useEffect, useCallback } from "react";
import useWindowSize from "../hooks/useWindowSize";
import apiService from "../services/api";
import LoadingSpinner from "../components/LoadingSpinner";
import ErrorMessage from "../components/ErrorMessage";
import seniorsIcon from "../assets/seniors.svg";
import caregiversIcon from "../assets/caregivers.svg";
import "../styles/pages/HomePage.css";

/* ═══════════════════════ CONSTANTS ═══════════════════════ */
const STAR_GOLD = "#fbbf24";
const STAR_GRAY = "#64748b";

/* ═══════════════════════ ICONS ═══════════════════════ */
const ICONS = {
    SENIORS_ICON: () => (
    <img 
      src={seniorsIcon} 
      alt="Seniors" 
      className="home-stat-card__icon" 
    />
  ),
  TOTAL_DEVICES_ICON: () => (
    <svg className="home-stat-card__icon" viewBox="0 0 24 24" fill="#ffffff">
      <path d="M17.4444 10H6.55556C6.143 10 5.74733 10.1639 5.45561 10.4556C5.16389 10.7473 5 11.143 5 11.5556V22.4444C5 22.857 5.16389 23.2527 5.45561 23.5444C5.74733 23.8361 6.143 24 6.55556 24H17.4444C17.857 24 18.2527 23.8361 18.5444 23.5444C18.8361 23.2527 19 22.857 19 22.4444V11.5556C19 11.143 18.8361 10.7473 18.5444 10.4556C18.2527 10.1639 17.857 10 17.4444 10ZM17.4444 20.8889C17.4444 21.3014 17.2806 21.6971 16.9888 21.9888C16.6971 22.2806 16.3014 22.4444 15.8889 22.4444C15.4763 22.4444 15.0807 22.2806 14.7889 21.9888C14.4972 21.6971 14.3333 21.3014 14.3333 20.8889C14.3333 20.4763 14.4972 20.0807 14.7889 19.7889C15.0807 19.4972 15.4763 19.3333 15.8889 19.3333C16.3014 19.3333 16.6971 19.4972 16.9888 19.7889C17.2806 20.0807 17.4444 20.4763 17.4444 20.8889ZM17.4444 12.7222C17.4444 13.0316 17.3215 13.3284 17.1027 13.5472C16.8839 13.766 16.5872 13.8889 16.2778 13.8889H7.72222C7.4128 13.8889 7.11606 13.766 6.89726 13.5472C6.67847 13.3284 6.55556 13.0316 6.55556 12.7222C6.55556 12.4128 6.67847 12.1161 6.89726 11.8973C7.11606 11.6785 7.4128 11.5556 7.72222 11.5556H16.2778C16.5872 11.5556 16.8839 11.6785 17.1027 11.8973C17.3215 12.1161 17.4444 12.4128 17.4444 12.7222Z" />
      <path d="M8.45997 7.46L7.04997 6.05C8.31997 4.78 10.07 4 12 4C13.93 4 15.68 4.78 16.95 6.05L15.54 7.46C14.63 6.56 13.38 6 12 6C10.62 6 9.36997 6.56 8.45997 7.46Z" />
      <path d="M4.21997 3.22C6.20997 1.23 8.95997 0 12 0C15.04 0 17.79 1.23 19.77 3.23L18.36 4.64C16.74 3.01 14.49 2 12 2C9.50997 2 7.25997 3.01 5.62997 4.63L4.21997 3.22" />
    </svg>
  ),
  ACTIVE_DEVICES_ICON: () => (
    <svg className="home-stat-card__icon home-stat-card--active" viewBox="0 0 24 24" fill="#22c55e">
      <path d="M17.4444 10H6.55556C6.143 10 5.74733 10.1639 5.45561 10.4556C5.16389 10.7473 5 11.143 5 11.5556V22.4444C5 22.857 5.16389 23.2527 5.45561 23.5444C5.74733 23.8361 6.143 24 6.55556 24H17.4444C17.857 24 18.2527 23.8361 18.5444 23.5444C18.8361 23.2527 19 22.857 19 22.4444V11.5556C19 11.143 18.8361 10.7473 18.5444 10.4556C18.2527 10.1639 17.857 10 17.4444 10ZM17.4444 20.8889C17.4444 21.3014 17.2806 21.6971 16.9888 21.9888C16.6971 22.2806 16.3014 22.4444 15.8889 22.4444C15.4763 22.4444 15.0807 22.2806 14.7889 21.9888C14.4972 21.6971 14.3333 21.3014 14.3333 20.8889C14.3333 20.4763 14.4972 20.0807 14.7889 19.7889C15.0807 19.4972 15.4763 19.3333 15.8889 19.3333C16.3014 19.3333 16.6971 19.4972 16.9888 19.7889C17.2806 20.0807 17.4444 20.4763 17.4444 20.8889ZM17.4444 12.7222C17.4444 13.0316 17.3215 13.3284 17.1027 13.5472C16.8839 13.766 16.5872 13.8889 16.2778 13.8889H7.72222C7.4128 13.8889 7.11606 13.766 6.89726 13.5472C6.67847 13.3284 6.55556 13.0316 6.55556 12.7222C6.55556 12.4128 6.67847 12.1161 6.89726 11.8973C7.11606 11.6785 7.4128 11.5556 7.72222 11.5556H16.2778C16.5872 11.5556 16.8839 11.6785 17.1027 11.8973C17.3215 12.1161 17.4444 12.4128 17.4444 12.7222Z" />
      <path d="M8.45997 7.46L7.04997 6.05C8.31997 4.78 10.07 4 12 4C13.93 4 15.68 4.78 16.95 6.05L15.54 7.46C14.63 6.56 13.38 6 12 6C10.62 6 9.36997 6.56 8.45997 7.46Z" />
      <path d="M4.21997 3.22C6.20997 1.23 8.95997 0 12 0C15.04 0 17.79 1.23 19.77 3.23L18.36 4.64C16.74 3.01 14.49 2 12 2C9.50997 2 7.25997 3.01 5.62997 4.63L4.21997 3.22" />
    </svg>
  ),
  INACTIVE_DEVICES_ICON: () => (
    <svg className="home-stat-card__icon home-stat-card--inactive" viewBox="0 0 24 24" fill="#ef4444">
      <path d="M17.4444 10H6.55556C6.143 10 5.74733 10.1639 5.45561 10.4556C5.16389 10.7473 5 11.143 5 11.5556V22.4444C5 22.857 5.16389 23.2527 5.45561 23.5444C5.74733 23.8361 6.143 24 6.55556 24H17.4444C17.857 24 18.2527 23.8361 18.5444 23.5444C18.8361 23.2527 19 22.857 19 22.4444V11.5556C19 11.143 18.8361 10.7473 18.5444 10.4556C18.2527 10.1639 17.857 10 17.4444 10ZM17.4444 20.8889C17.4444 21.3014 17.2806 21.6971 16.9888 21.9888C16.6971 22.2806 16.3014 22.4444 15.8889 22.4444C15.4763 22.4444 15.0807 22.2806 14.7889 21.9888C14.4972 21.6971 14.3333 21.3014 14.3333 20.8889C14.3333 20.4763 14.4972 20.0807 14.7889 19.7889C15.0807 19.4972 15.4763 19.3333 15.8889 19.3333C16.3014 19.3333 16.6971 19.4972 16.9888 19.7889C17.2806 20.0807 17.4444 20.4763 17.4444 20.8889ZM17.4444 12.7222C17.4444 13.0316 17.3215 13.3284 17.1027 13.5472C16.8839 13.766 16.5872 13.8889 16.2778 13.8889H7.72222C7.4128 13.8889 7.11606 13.766 6.89726 13.5472C6.67847 13.3284 6.55556 13.0316 6.55556 12.7222C6.55556 12.4128 6.67847 12.1161 6.89726 11.8973C7.11606 11.6785 7.4128 11.5556 7.72222 11.5556H16.2778C16.5872 11.5556 16.8839 11.6785 17.1027 11.8973C17.3215 12.1161 17.4444 12.4128 17.4444 12.7222Z" />
      <path d="M8.45997 7.46L7.04997 6.05C8.31997 4.78 10.07 4 12 4C13.93 4 15.68 4.78 16.95 6.05L15.54 7.46C14.63 6.56 13.38 6 12 6C10.62 6 9.36997 6.56 8.45997 7.46Z" />
      <path d="M4.21997 3.22C6.20997 1.23 8.95997 0 12 0C15.04 0 17.79 1.23 19.77 3.23L18.36 4.64C16.74 3.01 14.49 2 12 2C9.50997 2 7.25997 3.01 5.62997 4.63L4.21997 3.22" />
    </svg>
  )
};

// Cache for dashboard data
let cachedDashboard = null;
let cacheTimestamp = null;
const CACHE_DURATION = 5 * 60 * 1000; // 5 minutes

// Cache for residents data (shared with Sidebar)
let cachedResidents = null;
let residentsCacheTimestamp = null;
const RESIDENTS_CACHE_DURATION = 2 * 60 * 1000; // 2 minutes

// Export function to invalidate cache (called on logout or facility switch)
export function invalidateDashboardCache() {
  cachedDashboard = null;
  cacheTimestamp = null;
  cachedResidents = null;
  residentsCacheTimestamp = null;
}

// Invalidate cache on page visibility change (covers logout/login scenarios)
if (typeof document !== 'undefined') {
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible' && cacheTimestamp) {
      const elapsed = Date.now() - cacheTimestamp;
      if (elapsed > CACHE_DURATION) {
        invalidateDashboardCache();
      }
    }
  });
}

export default function HomePage({ onNavigate, onNavigateWithResident, onResidentClick, onCaregiverClick }) {
  const now = Date.now();
  const hasCachedData = cachedDashboard && cacheTimestamp && (now - cacheTimestamp) < CACHE_DURATION;
  
  const [loading, setLoading] = useState(!hasCachedData);
  const [error, setError] = useState(null);
  const [dashboardData, setDashboardData] = useState(
    hasCachedData ? cachedDashboard : {
      stats: { totalSeniors: 0, age5060: 0, age6070: 0, age70Above: 0, totalDevices: 0, activeDevices: 0, inactiveDevices: 0 },
      qualityMetrics: { sleepQuality: null, gaitQuality: null, fallSafety: null },
      allResidents: [],
      allCaregivers: [],
      overviews: { sleep: null, gait: null, fall: null }
    }
  );
  
  // Pagination states
  const [residentsPage, setResidentsPage] = useState(1);
  const [caregiversPage, setCaregiversPage] = useState(1);
  const itemsPerPage = 4;
  
  // Search states - must be declared before any early returns
  const [residentsSearchQuery, setResidentsSearchQuery] = useState("");
  const [caregiversSearchQuery, setCaregiversSearchQuery] = useState("");
  
  const { isMobile } = useWindowSize();

  // Wrap loadDashboardData in useCallback to prevent infinite loop
  const loadDashboardData = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);

      // Check if we have cached residents data
      const now = Date.now();
      let residents = [];

      if (cachedResidents && residentsCacheTimestamp && (now - residentsCacheTimestamp) < RESIDENTS_CACHE_DURATION) {
        residents = cachedResidents;
      } else {
        const residentsData = await apiService.getAllResidents();
        residents = residentsData.residents || [];
        cachedResidents = residents;
        residentsCacheTimestamp = now;
      }

            console.log('[Dashboard] Fetching devices and caregivers...');
      const [devicesData, caregiversData] = await Promise.all([
        apiService.getDevices().catch((err) => {
          console.error('[Dashboard] Failed to fetch devices:', err);
          return { devices: [] };
        }),
        apiService.getAllCaregivers(true).catch((err) => { // Bust cache
          console.error('[Dashboard] Failed to fetch caregivers:', err);
          return { caregivers: [] };
        })
      ]);
      const devices = devicesData.devices || [];
      const caregivers = caregiversData.caregivers || [];
      
      console.log('[Dashboard] Devices fetched:', devices.length);
      console.log('[Dashboard] Caregivers fetched:', caregivers.length);
      console.log('[Dashboard] Caregivers data:', caregiversData);

      if (residents.length === 0) {
        setLoading(false);
        return;
      }

      const age5060 = residents.filter(r => r.age >= 50 && r.age < 60).length;
      const age6070 = residents.filter(r => r.age >= 60 && r.age < 70).length;
      const age70Above = residents.filter(r => r.age >= 70).length;
      
      console.log('[Dashboard] Age distribution:', { age5060, age6070, age70Above, total: residents.length });
      
      const activeDevices = devices.filter(d => d.status === 'ONLINE').length;
      const inactiveDevices = devices.filter(d => d.status !== 'ONLINE').length;
      
      // Fetch aggregated dashboard metrics from single endpoint
      let dashboardMetrics = {
        quality_metrics: {
          sleep_quality_stars: null,
          gait_quality_stars: null,
          fall_safety_stars: null
        },
        overview: {
          sleep: { poor_sleep_count: 0, top_concerns: [] },
          gait: { unstable_gait_count: 0, top_concerns: [] },
          fall: { falls_24hr: 0, repeat_fallers: [] }
        }
      };

      try {
        dashboardMetrics = await apiService.getDashboardMetrics();
      } catch (e) {
        // Failed to fetch dashboard metrics, using defaults
      }
      
      // Map all residents
      const allResidents = residents.map(r => {
        const parts = r.status_name_sort?.split('--');
        const name = (parts && parts[2] && parts[1]) ? `${parts[2]} ${parts[1]}` : 'Unknown';
        return {
          id: r.resident_id,
          name,
          photo: r.photo_s3_key
        };
      });
      
      // Map all caregivers
      const allCaregivers = caregivers.map(c => {
        let displayName = 'Unknown Caregiver';
        if (c.display_name) {
          displayName = c.display_name;
        } else if (c.first_name || c.last_name) {
          displayName = `${c.first_name || ''} ${c.last_name || ''}`.trim();
        }
        return {
          id: c.caregiver_id,
          name: displayName,
          role: c.role || 'N/A'
        };
      });
      
      // Generate dynamic, informative overviews based on actual facility data
      const sleepOverview = dashboardMetrics.overview.sleep;
      const gaitOverview = dashboardMetrics.overview.gait;
      const fallOverview = dashboardMetrics.overview.fall;
      
      console.log('[Dashboard] Fall Overview Data:', {
        falls_24hr: fallOverview.falls_24hr,
        repeat_fallers: fallOverview.repeat_fallers,
        repeat_fallers_count: fallOverview.repeat_fallers?.length || 0
      });
      
      // Check if we have any actual data (not just default values)
      const hasSleepData = sleepOverview.poor_sleep_count > 0 || sleepOverview.high_waso_count > 0 || 
                           (sleepOverview.top_concerns && sleepOverview.top_concerns.length > 0);
      const hasGaitData = gaitOverview.unstable_gait_count > 0 || gaitOverview.irregular_patterns_count > 0 || 
                          (gaitOverview.top_concerns && gaitOverview.top_concerns.length > 0);
      const hasFallData = fallOverview.falls_24hr > 0 || fallOverview.high_risk_count > 0 || 
                          (fallOverview.repeat_fallers && fallOverview.repeat_fallers.length > 0);
      
      const overviews = {
        sleep: {
          title: 'Sleep Diary Overview',
          bullets: [
            { 
              text: !hasSleepData
                ? `Sleep monitoring system active and ready`
                : sleepOverview.poor_sleep_count === 0
                ? residents.length === 1
                  ? `The resident achieved adequate sleep last night`
                  : `All ${residents.length} residents achieved adequate sleep last night`
                : sleepOverview.poor_sleep_count === 1
                ? `1 resident had poor sleep quality last night`
                : `${sleepOverview.poor_sleep_count} residents had poor sleep quality last night`, 
              avatars: sleepOverview.top_concerns || [] 
            },
            { 
              text: !hasSleepData
                ? `Tracking sleep patterns and interruptions`
                : sleepOverview.high_waso_count === 0
                ? residents.length === 1
                  ? `The resident experienced no frequent sleep interruptions`
                  : `No residents experienced frequent sleep interruptions`
                : sleepOverview.high_waso_count === 1
                ? `1 resident had more than 3 sleep breaks`
                : `${sleepOverview.high_waso_count} residents had more than 3 sleep breaks`,
              avatars: sleepOverview.high_waso_residents || [] 
            },
            { 
              text: !hasSleepData
                ? `No sleep data recorded yet - awaiting first night's data`
                : sleepOverview.poor_sleep_count > 0 && sleepOverview.top_concerns?.[0]
                ? `Top Concern: ${sleepOverview.top_concerns[0].name} – ${sleepOverview.top_concerns[0].value} (Least Sleep)` 
                : sleepOverview.high_waso_count > 0 && sleepOverview.high_waso_residents?.[0]
                ? `Most Disrupted: ${sleepOverview.high_waso_residents[0].name} – ${sleepOverview.high_waso_residents[0].value}`
                : `Facility-wide sleep quality: Excellent`,
              avatars: sleepOverview.poor_sleep_count > 0 && sleepOverview.top_concerns?.length > 0 ? [sleepOverview.top_concerns[0]] : [] 
            }
          ]
        },
        gait: {
          title: 'Gait Analysis Overview',
          bullets: [
            { 
              text: !hasGaitData
                ? `Gait analysis system active and monitoring`
                : gaitOverview.unstable_gait_count === 0
                ? residents.length === 1
                  ? `The resident is showing stable gait patterns today`
                  : `All ${residents.length} residents showing stable gait patterns today`
                : gaitOverview.unstable_gait_count === 1
                ? `1 resident flagged for unstable gait today`
                : `${gaitOverview.unstable_gait_count} residents flagged for unstable gait today`, 
              avatars: gaitOverview.top_concerns || [] 
            },
            { 
              text: !hasGaitData
                ? `Analyzing walking patterns and balance metrics`
                : gaitOverview.irregular_patterns_count === 0
                ? residents.length === 1
                  ? `The resident is maintaining normal step patterns`
                  : `All residents maintaining normal step patterns`
                : gaitOverview.irregular_patterns_count === 1
                ? `1 resident showed irregular step patterns during monitoring`
                : `${gaitOverview.irregular_patterns_count} residents showed irregular step patterns during monitoring`,
              avatars: gaitOverview.irregular_residents || [] 
            },
            { 
              text: !hasGaitData
                ? `No gait data recorded yet - awaiting movement analysis`
                : gaitOverview.unstable_gait_count > 0 && gaitOverview.top_concerns?.[0]
                ? `Most At Risk: ${gaitOverview.top_concerns[0].name} – Balance ${gaitOverview.top_concerns[0].value}`
                : gaitOverview.irregular_patterns_count > 0 && gaitOverview.irregular_residents?.[0]
                ? `Attention Needed: ${gaitOverview.irregular_residents[0].name} – ${gaitOverview.irregular_residents[0].value}`
                : `Facility-wide gait stability: Excellent`,
              avatars: [] 
            }
          ]
        },
        fall: {
          title: 'Fall Detection Overview',
          bullets: [
            { 
              text: !hasFallData
                ? `Fall detection system active and monitoring 24/7`
                : fallOverview.falls_24hr === 0
                ? `No fall incidents reported in the last 7 days`
                : fallOverview.falls_24hr === 1
                ? `1 resident experienced a fall in the last 7 days`
                : `${fallOverview.falls_24hr} residents experienced falls in the last 7 days`, 
              avatars: fallOverview.repeat_fallers || [] 
            },
            { 
              text: !hasFallData
                ? `All facility areas under active fall detection`
                : fallOverview.top_location && fallOverview.top_location !== 'N/A'
                ? `Most Common Location: ${fallOverview.top_location} (${fallOverview.top_location_count} incident${fallOverview.top_location_count > 1 ? 's' : ''})`
                : fallOverview.monitored_areas_count > 0
                ? `Monitoring ${fallOverview.monitored_areas_count} areas facility-wide`
                : `All facility areas under active fall detection`,
              avatars: [] 
            },
            { 
              text: !hasFallData
                ? residents.length === 1
                  ? `The resident has low fall risk status`
                  : `All residents: Low fall risk status`
                : fallOverview.high_risk_count > 0
                ? `${fallOverview.high_risk_count} resident${fallOverview.high_risk_count > 1 ? 's' : ''} identified as high fall risk`
                : residents.length === 1
                  ? `The resident has low fall risk status`
                  : `All residents: Low fall risk status`,
              avatars: fallOverview.high_risk_residents || [] 
            }
          ]
        }
      };
      
      const newDashboard = {
        stats: {
          totalSeniors: residents.length,
          age5060,
          age6070,
          age70Above,
          totalDevices: devices.length,
          activeDevices,
          inactiveDevices
        },
        qualityMetrics: {
          sleepQuality: dashboardMetrics.quality_metrics.sleep_quality_stars,
          gaitQuality: dashboardMetrics.quality_metrics.gait_quality_stars,
          fallSafety: dashboardMetrics.quality_metrics.fall_safety_stars
        },
        allResidents,
        allCaregivers,
        overviews
      };
      
      cachedDashboard = newDashboard;
      cacheTimestamp = Date.now();
      setDashboardData(newDashboard);

    } catch (err) {
      setError(err);
    } finally {
      setLoading(false);
    }
  }, []);

  // Load dashboard data on mount (skip if valid cache already loaded into state)
  useEffect(() => {
    const now = Date.now();
    const isCacheValid = cachedDashboard && cacheTimestamp && (now - cacheTimestamp) < CACHE_DURATION;
    if (!isCacheValid) {
      loadDashboardData();
    }
  }, [loadDashboardData]);

  if (loading) {
    return (
      <main style={{ flex: 1, display: "flex", alignItems: "center", justifyContent: "center", paddingTop: 120, minHeight: "100vh" }}>
        <LoadingSpinner message="Loading dashboard..." />
      </main>
    );
  }

  if (error) {
    return (
      <main style={{ flex: 1, display: "flex", alignItems: "center", justifyContent: "center", paddingTop: 120, minHeight: "100vh" }}>
        <ErrorMessage error={error} onRetry={loadDashboardData} />
      </main>
    );
  }

  const { stats, qualityMetrics, allResidents, allCaregivers, overviews } = dashboardData;
  
  // Filter residents based on search query BEFORE pagination
  const filteredResidents = allResidents.filter(resident => {
    if (!residentsSearchQuery.trim()) return true;
    const query = residentsSearchQuery.toLowerCase();
    return resident.name.toLowerCase().includes(query);
  });
  
  // Filter caregivers based on search query BEFORE pagination
  const filteredCaregivers = allCaregivers.filter(caregiver => {
    if (!caregiversSearchQuery.trim()) return true;
    const query = caregiversSearchQuery.toLowerCase();
    return caregiver.name.toLowerCase().includes(query);
  });
  
  // Calculate pagination for residents (using filtered list)
  const totalResidentsPages = Math.ceil(filteredResidents.length / itemsPerPage);
  const residentsStartIndex = (residentsPage - 1) * itemsPerPage;
  const residentsEndIndex = residentsStartIndex + itemsPerPage;
  const currentResidents = filteredResidents.slice(residentsStartIndex, residentsEndIndex);
  
  // Calculate pagination for caregivers (using filtered list)
  const totalCaregiversPages = Math.ceil(filteredCaregivers.length / itemsPerPage);
  const caregiversStartIndex = (caregiversPage - 1) * itemsPerPage;
  const caregiversEndIndex = caregiversStartIndex + itemsPerPage;
  const currentCaregivers = filteredCaregivers.slice(caregiversStartIndex, caregiversEndIndex);

  return (
        <main style={{
      flex: 1,
      padding: isMobile ? "75px 12px 40px 12px" : "82px 40px 40px 40px",
      overflowY: "auto",
      overflowX: "hidden",
      background: "linear-gradient(160deg, #b8d4f0 0%, #9ec4ea 30%, #7daed8 60%, #6a9ccc 100%)",
      fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
      minHeight: "100vh",
      width: "100%",
      boxSizing: "border-box"
    }}>
                                                {/* TOP ROW: Three equal columns - Seniors+Devices+Stars | Residents | Caregivers */}
            <div style={{ display: "grid", gridTemplateColumns: isMobile ? "1fr" : "repeat(3, 1fr)", gap: 12, marginBottom: 12, width: "100%", boxSizing: "border-box" }}>
        
        {/* COLUMN 1: Seniors + Devices + Quality Stars */}
        <div className="home-stats-column">
          {/* 2x2 Grid with equal row heights */}
          <div className="home-stats-grid">
            <SeniorsCard stats={stats} />
            <TotalDevicesCard value={stats.totalDevices} />
            <ActiveDevicesCard value={stats.activeDevices} />
            <InactiveDevicesCard value={stats.inactiveDevices} />
          </div>
    
          {/* Quality Stars */}
          <div className="home-quality-card">
            <QualityRow label="Sleep Quality :" stars={qualityMetrics.sleepQuality} />
            <QualityRow label="Gait Quality" stars={qualityMetrics.gaitQuality} />
            <QualityRow label="Fall" stars={qualityMetrics.fallSafety} />
          </div>
        </div>
  
        {/* COLUMN 2: Residents List */}
        <ResidentsListCard 
          residents={currentResidents} 
          currentPage={residentsPage}
          totalPages={totalResidentsPages}
          onPageChange={setResidentsPage}
          searchQuery={residentsSearchQuery}
          setSearchQuery={setResidentsSearchQuery}
          onNavigate={onNavigate}
          onResidentClick={onResidentClick}
        />
  
        {/* COLUMN 3: Caregivers List */}
        <CaregiversListCard 
          caregivers={currentCaregivers}
          currentPage={caregiversPage}
          totalPages={totalCaregiversPages}
          onPageChange={setCaregiversPage}
          searchQuery={caregiversSearchQuery}
          setSearchQuery={setCaregiversSearchQuery}
          onNavigate={onNavigate}
          onCaregiverClick={onCaregiverClick}
        />
      </div>

      {/* BOTTOM ROW: Three Overview Cards with equal widths */}
      <div className={`home-bottom-grid ${isMobile ? 'mobile' : ''}`}>
        <OverviewCard 
          data={overviews.sleep} 
          onClick={() => onNavigate && onNavigate("Sleep Diary")} 
          onAvatarClick={(residentId) => onNavigateWithResident && onNavigateWithResident("Sleep Diary", residentId)}
        />
        <OverviewCard 
          data={overviews.gait} 
          onClick={() => onNavigate && onNavigate("Gait")} 
          onAvatarClick={(residentId) => onNavigateWithResident && onNavigateWithResident("Gait", residentId)}
        />
        <OverviewCard 
          data={overviews.fall} 
          onClick={() => onNavigate && onNavigate("Falls")} 
          onAvatarClick={(residentId) => onNavigateWithResident && onNavigateWithResident("Falls", residentId)}
        />
      </div>
    </main>
  );
}

/* ═══════════════════════ SENIORS CARD ═══════════════════════ */
function SeniorsCard({ stats }) {
  return (
    <div className="home-stat-card">
      {/* Centered Icon */}
      <div className="home-stat-card__icon">{ICONS.SENIORS_ICON()}</div>
      
      {/* Main label with vertical separator and count */}
      <div className="home-stat-card__main-row">
        <div className="home-stat-card__label">Seniors</div>
        <div className="home-stat-card__separator" />
        <div className="home-stat-card__count">{stats.totalSeniors}</div>
      </div>
      
      {/* Age breakdown rows */}
      <div className="home-stat-card__breakdown">
        <div className="home-stat-card__breakdown-row">
          <span className="home-stat-card__breakdown-label">Age 60-70 Patients</span>
          <span className="home-stat-card__breakdown-value">{stats.age6070}</span>
        </div>
        <div className="home-stat-card__breakdown-row">
          <span className="home-stat-card__breakdown-label">Age 70+ Patients</span>
          <span className="home-stat-card__breakdown-value">{stats.age70Above}</span>
        </div>
      </div>
    </div>
  );
}

/* ═══════════════════════ DEVICE CARDS ═══════════════════════ */
function TotalDevicesCard({ value }) {
  return (
    <div className="home-stat-card">
      <div className="home-stat-card__icon">{ICONS.TOTAL_DEVICES_ICON()}</div>
      <div className="home-stat-card__main-row">
        <div className="home-stat-card__label">Total Devices</div>
        <div className="home-stat-card__separator" />
        <div className="home-stat-card__count">{value}</div>
      </div>
    </div>
  );
}

function ActiveDevicesCard({ value }) {
  return (
    <div className="home-stat-card">
      <div className="home-stat-card__icon">{ICONS.ACTIVE_DEVICES_ICON()}</div>
      <div className="home-stat-card__main-row">
        <div className="home-stat-card__label">Active Devices</div>
        <div className="home-stat-card__separator" />
        <div className="home-stat-card__count">{value}</div>
      </div>
    </div>
  );
}

function InactiveDevicesCard({ value }) {
  return (
    <div className="home-stat-card">
      <div className="home-stat-card__icon">{ICONS.INACTIVE_DEVICES_ICON()}</div>
      <div className="home-stat-card__main-row">
        <div className="home-stat-card__label">Inactive Devices</div>
        <div className="home-stat-card__separator" />
        <div className="home-stat-card__count">{value}</div>
      </div>
    </div>
  );
}

/* ═══════════════════════ QUALITY ROW ═══════════════════════ */
function QualityRow({ label, stars }) {
  const hasData = stars !== null && stars !== undefined;
  
  return (
    <div className="home-quality-row">
      <div className="home-quality-row__label">{label}</div>
      {hasData ? (
        <div className="home-quality-row__stars">
          {[1, 2, 3, 4, 5].map(i => (
            <svg key={i} className={`home-quality-row__star ${i <= stars ? 'home-quality-row__star--filled' : 'home-quality-row__star--empty'}`} viewBox="0 0 24 24" fill={i <= stars ? STAR_GOLD : STAR_GRAY}>
              <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
            </svg>
          ))}
        </div>
      ) : (
        <div className="home-quality-row__no-data">
          No Data
        </div>
      )}
    </div>
  );
}

/* ═══════════════════════ RESIDENTS LIST CARD ═══════════════════════ */
function ResidentsListCard({ residents, currentPage, totalPages, onPageChange, searchQuery, setSearchQuery, onNavigate, onResidentClick }) {
  return (
    <div className="home-list-card">
      {/* Search Bar with Icon */}
            <div className="home-list-card__search">
        <div className="home-list-card__search-icon">
          <img 
            src={seniorsIcon} 
            alt="Seniors" 
          />
        </div>
        <input
          type="text"
          placeholder="Search Seniors"
          value={searchQuery}
          onChange={(e) => { setSearchQuery(e.target.value); onPageChange(1); }}
          className="home-list-card__search-input"
        />
      </div>
      
      {/* Column Headers */}
      <div className="home-list-card__headers">
        <div className="home-list-card__header home-list-card__header--left">Profile</div>
        <div className="home-list-card__header home-list-card__header--center">Name</div>
        <div className="home-list-card__header home-list-card__header--center">Action</div>
      </div>
      
      {/* Resident Rows */}
      <div className="home-list-card__rows">
        {residents.length === 0 ? (
          <div className="home-list-card__empty">
            {searchQuery ? "No residents found" : "No residents available"}
          </div>
        ) : (
          residents.map((resident, i) => (
            <div key={i} className="home-list-card__row">
              <div>
                <div className="home-list-card__row-avatar">
                  {resident.name.split(' ').map(n => n[0]).join('')}
                </div>
              </div>
              <div className="home-list-card__row-name">{resident.name}</div>
              <div className="home-list-card__row-action">
                <button
                  onClick={(e) => {
                    e.stopPropagation();
                    onResidentClick && onResidentClick(resident.id);
                  }}
                  className="home-list-card__row-button"
                >
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2.5">
                    <path d="M9 18l6-6-6-6"/>
                  </svg>
                </button>
              </div>
            </div>
          ))
        )}
      </div>
      
      {/* Pagination */}
      {totalPages > 1 && (
        <div className="home-list-card__pagination">
          {/* Previous Button */}
          <button
            onClick={() => onPageChange(Math.max(1, currentPage - 1))}
            disabled={currentPage === 1}
            className={`home-list-card__page-btn home-list-card__page-btn--nav ${currentPage === 1 ? 'home-list-card__page-btn--disabled' : ''}`}
          >
            ‹
          </button>
          
          {/* Page Numbers */}
          {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
            <button
              key={page}
              onClick={() => onPageChange(page)}
              className={`home-list-card__page-btn ${currentPage === page ? 'home-list-card__page-btn--active' : ''}`}
            >
              {page}
            </button>
          ))}
          
          {/* Next Button */}
          <button
            onClick={() => onPageChange(Math.min(totalPages, currentPage + 1))}
            disabled={currentPage === totalPages}
            className={`home-list-card__page-btn home-list-card__page-btn--nav ${currentPage === totalPages ? 'home-list-card__page-btn--disabled' : ''}`}
          >
            ›
          </button>
        </div>
      )}
    </div>
  );
}

/* ═══════════════════════ CAREGIVERS LIST CARD ═══════════════════════ */
function CaregiversListCard({ caregivers, currentPage, totalPages, onPageChange, searchQuery, setSearchQuery, onNavigate, onCaregiverClick }) {
  return (
    <div className="home-list-card">
      {/* Search Bar with Icon */}
      <div className="home-list-card__search">
        <div className="home-list-card__search-icon">
          <img 
            src={caregiversIcon} 
            alt="Caregivers" 
          />
        </div>
        <input
          type="text"
          placeholder="Search Caregivers"
          value={searchQuery}
          onChange={(e) => { setSearchQuery(e.target.value); onPageChange(1); }}
          className="home-list-card__search-input"
        />
      </div>
      
      {/* Column Headers */}
      <div className="home-list-card__headers">
        <div className="home-list-card__header home-list-card__header--left">Profile</div>
        <div className="home-list-card__header home-list-card__header--center">Name</div>
        <div className="home-list-card__header home-list-card__header--center">Action</div>
      </div>
      
      {/* Caregiver Rows */}
      <div className="home-list-card__rows">
        {caregivers.length === 0 ? (
          <div className="home-list-card__empty">
            {searchQuery ? "No caregivers found" : "No caregivers available"}
          </div>
        ) : (
          caregivers.map((caregiver, i) => (
            <div key={i} className="home-list-card__row">
              <div>
                <div className="home-list-card__row-avatar home-list-card__row-avatar--caregiver">
                  {caregiver.name.split(' ').map(n => n[0]).join('')}
                </div>
              </div>
              <div className="home-list-card__row-name">{caregiver.name}</div>
              <div className="home-list-card__row-action">
                <button
                  onClick={(e) => {
                    e.stopPropagation();
                    onCaregiverClick && onCaregiverClick(caregiver.id);
                  }}
                  className="home-list-card__row-button"
                >
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2.5">
                    <path d="M9 18l6-6-6-6"/>
                  </svg>
                </button>
              </div>
            </div>
          ))
        )}
      </div>
      
      {/* Pagination */}
      {totalPages > 1 && (
        <div className="home-list-card__pagination">
          {/* Previous Button */}
          <button
            onClick={() => onPageChange(Math.max(1, currentPage - 1))}
            disabled={currentPage === 1}
            className={`home-list-card__page-btn home-list-card__page-btn--nav ${currentPage === 1 ? 'home-list-card__page-btn--disabled' : ''}`}
          >
            ‹
          </button>
          
          {/* Page Numbers */}
          {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
            <button
              key={page}
              onClick={() => onPageChange(page)}
              className={`home-list-card__page-btn ${currentPage === page ? 'home-list-card__page-btn--active' : ''}`}
            >
              {page}
            </button>
          ))}
          
          {/* Next Button */}
          <button
            onClick={() => onPageChange(Math.min(totalPages, currentPage + 1))}
            disabled={currentPage === totalPages}
            className={`home-list-card__page-btn home-list-card__page-btn--nav ${currentPage === totalPages ? 'home-list-card__page-btn--disabled' : ''}`}
          >
            ›
          </button>
        </div>
      )}
    </div>
  );
}

/* ═══════════════════════ AVATAR CAROUSEL COMPONENT ═══════════════════════ */
function AvatarCarousel({ avatars, onAvatarClick }) {
  const [startIndex, setStartIndex] = useState(0);
  const itemsPerView = 4;
  
  const visibleAvatars = avatars.slice(startIndex, startIndex + itemsPerView);
  
  const handlePrev = (e) => {
    e.stopPropagation();
    setStartIndex(Math.max(0, startIndex - itemsPerView));
  };
  
  const handleNext = (e) => {
    e.stopPropagation();
    setStartIndex(Math.min(avatars.length - itemsPerView, startIndex + itemsPerView));
  };
  
  return (
    <div className="home-overview-card__avatars">
      {/* Left Arrow */}
      {startIndex > 0 && (
        <button
          onClick={handlePrev}
          className="home-overview-card__avatar-btn"
        >
          <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="3">
            <path d="M15 18l-6-6 6-6"/>
          </svg>
        </button>
      )}
      
      {/* Avatars */}
      <div className="home-overview-card__avatar-list">
        {visibleAvatars.map((avatar, j) => (
          <div 
            key={j} 
            title={`${avatar.name}: ${avatar.value}`}
            onClick={(e) => {
              e.stopPropagation();
              if (onAvatarClick && avatar.resident_id) {
                onAvatarClick(avatar.resident_id);
              }
            }}
            className="home-overview-card__avatar"
          >
            {avatar.name.split(' ').map(n => n[0]).join('')}
          </div>
        ))}
      </div>
      
      {/* Right Arrow */}
      {startIndex + itemsPerView < avatars.length && (
        <button
          onClick={handleNext}
          className="home-overview-card__avatar-btn"
        >
          <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="3">
            <path d="M9 18l6-6-6-6"/>
          </svg>
        </button>
      )}
    </div>
  );
}

/* ═══════════════════════ OVERVIEW CARD ═══════════════════════ */
function OverviewCard({ data, onClick, onAvatarClick }) {
  const [isHovered, setIsHovered] = useState(false);
  if (!data) return null;
  
  return (
    <div 
      onClick={onClick} 
      onMouseEnter={() => setIsHovered(true)} 
      onMouseLeave={() => setIsHovered(false)} 
      className="home-overview-card"
      style={{ boxShadow: isHovered ? "0 8px 24px rgba(0,0,0,0.5)" : "0 4px 16px rgba(0,0,0,0.3)" }}
    >
      <h3 className="home-overview-card__title">
        {data.title}
      </h3>
      
      <div className="home-overview-card__bullets">
        {data.bullets.map((bullet, i) => (
          <div key={i} className="home-overview-card__bullet">
            {/* Info Icon */}
            <div className="home-overview-card__bullet-icon">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                <circle cx="12" cy="12" r="10" fill="#f59e0b" opacity="0.9"/>
                <path d="M12 16v-4m0-4h.01" stroke="#fff" strokeWidth="2.5" strokeLinecap="round"/>
              </svg>
            </div>
            
            {/* Text Content and Avatars Container */}
            <div className="home-overview-card__bullet-content">
              {/* Text Content */}
              <div className="home-overview-card__bullet-text">
                {bullet.text}
              </div>
              
              {/* Avatars with Carousel Navigation */}
              {bullet.avatars && bullet.avatars.length > 0 && (
                <AvatarCarousel avatars={bullet.avatars} onAvatarClick={onAvatarClick} />
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
